"use strict";
exports.__esModule = true;
exports.getLabelColorMap = void 0;
var tokens_1 = require("@atlaskit/tokens");
function getLabelColorMap(t) {
    var _a, _b;
    var context = t.getContext();
    var theme = (_b = (_a = context.theme) !== null && _a !== void 0 ? _a : context.initialTheme) !== null && _b !== void 0 ? _b : 'light';
    var isLightMode = theme === 'light';
    return {
        backgroundColor: {
            green_light: (0, tokens_1.getTokenValue)('color.background.accent.green.subtler'),
            green: (0, tokens_1.getTokenValue)('color.background.accent.green.subtle'),
            green_dark: (0, tokens_1.getTokenValue)('color.background.accent.green.bolder'),
            yellow_light: (0, tokens_1.getTokenValue)('color.background.accent.yellow.subtler'),
            yellow: (0, tokens_1.getTokenValue)('color.background.accent.yellow.subtle'),
            yellow_dark: (0, tokens_1.getTokenValue)('color.background.accent.yellow.bolder'),
            orange_light: (0, tokens_1.getTokenValue)('color.background.accent.orange.subtler'),
            orange: (0, tokens_1.getTokenValue)('color.background.accent.orange.subtle'),
            orange_dark: (0, tokens_1.getTokenValue)('color.background.accent.orange.bolder'),
            red_light: (0, tokens_1.getTokenValue)('color.background.accent.red.subtler'),
            red: (0, tokens_1.getTokenValue)('color.background.accent.red.subtle'),
            red_dark: (0, tokens_1.getTokenValue)('color.background.accent.red.bolder'),
            purple_light: (0, tokens_1.getTokenValue)('color.background.accent.purple.subtler'),
            purple: (0, tokens_1.getTokenValue)('color.background.accent.purple.subtle'),
            purple_dark: (0, tokens_1.getTokenValue)('color.background.accent.purple.bolder'),
            blue_light: (0, tokens_1.getTokenValue)('color.background.accent.blue.subtler'),
            blue: (0, tokens_1.getTokenValue)('color.background.accent.blue.subtle'),
            blue_dark: (0, tokens_1.getTokenValue)('color.background.accent.blue.bolder'),
            sky_light: (0, tokens_1.getTokenValue)('color.background.accent.teal.subtler'),
            sky: (0, tokens_1.getTokenValue)('color.background.accent.teal.subtle'),
            sky_dark: (0, tokens_1.getTokenValue)('color.background.accent.teal.bolder'),
            lime_light: isLightMode ? '#d3f1a7' : '#37471f',
            lime: isLightMode ? '#94c748' : '#4c6b1f',
            lime_dark: isLightMode ? '#5b7f24' : '#94c748',
            pink_light: (0, tokens_1.getTokenValue)('color.background.accent.magenta.subtler'),
            pink: (0, tokens_1.getTokenValue)('color.background.accent.magenta.subtle'),
            pink_dark: (0, tokens_1.getTokenValue)('color.background.accent.magenta.bolder'),
            black_light: (0, tokens_1.getTokenValue)('color.background.accent.gray.subtler'),
            black: (0, tokens_1.getTokenValue)('color.background.accent.gray.subtle'),
            black_dark: (0, tokens_1.getTokenValue)('color.background.accent.gray.bolder'),
            gray: (0, tokens_1.getTokenValue)('color.skeleton')
        },
        color: {
            green_light: (0, tokens_1.getTokenValue)('color.text.accent.green.bolder'),
            green: (0, tokens_1.getTokenValue)('color.text.accent.green.bolder'),
            green_dark: (0, tokens_1.getTokenValue)('color.text.inverse'),
            yellow_light: (0, tokens_1.getTokenValue)('color.text.accent.yellow.bolder'),
            yellow: (0, tokens_1.getTokenValue)('color.text.accent.yellow.bolder'),
            yellow_dark: (0, tokens_1.getTokenValue)('color.text.inverse'),
            orange_light: (0, tokens_1.getTokenValue)('color.text.accent.orange.bolder'),
            orange: (0, tokens_1.getTokenValue)('color.text.accent.orange.bolder'),
            orange_dark: (0, tokens_1.getTokenValue)('color.text.inverse'),
            red_light: (0, tokens_1.getTokenValue)('color.text.accent.red.bolder'),
            red: (0, tokens_1.getTokenValue)('color.text.accent.red.bolder'),
            red_dark: (0, tokens_1.getTokenValue)('color.text.inverse'),
            purple_light: (0, tokens_1.getTokenValue)('color.text.accent.purple.bolder'),
            purple: (0, tokens_1.getTokenValue)('color.text.accent.purple.bolder'),
            purple_dark: (0, tokens_1.getTokenValue)('color.text.inverse'),
            blue_light: (0, tokens_1.getTokenValue)('color.text.accent.blue.bolder'),
            blue: (0, tokens_1.getTokenValue)('color.text.accent.blue.bolder'),
            blue_dark: (0, tokens_1.getTokenValue)('color.text.inverse'),
            sky_light: (0, tokens_1.getTokenValue)('color.text.accent.teal.bolder'),
            sky: (0, tokens_1.getTokenValue)('color.text.accent.teal.bolder'),
            sky_dark: (0, tokens_1.getTokenValue)('color.text.inverse'),
            lime_light: isLightMode ? '#37471f' : '#d3f1a7',
            lime: isLightMode ? '#37471f' : '#d3f1a7',
            lime_dark: (0, tokens_1.getTokenValue)('color.text.inverse'),
            pink_light: (0, tokens_1.getTokenValue)('color.text.accent.magenta.bolder'),
            pink: (0, tokens_1.getTokenValue)('color.text.accent.magenta.bolder'),
            pink_dark: (0, tokens_1.getTokenValue)('color.text.inverse'),
            black_light: (0, tokens_1.getTokenValue)('color.text.accent.gray.bolder'),
            black: (0, tokens_1.getTokenValue)('color.text.accent.gray.bolder'),
            black_dark: (0, tokens_1.getTokenValue)('color.text.inverse'),
            gray: (0, tokens_1.getTokenValue)('color.skeleton')
        }
    };
}
exports.getLabelColorMap = getLabelColorMap;
//# sourceMappingURL=labelColors.js.map